import React, { useImperativeHandle, forwardRef, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../utils/constants";

const Captcha = forwardRef((props, ref) => {
  const recaptchaRef = useRef(null);

  // Expose methods to parent component via ref
  useImperativeHandle(ref, () => ({
    validate: () => {
      const recaptchaValue = recaptchaRef.current?.getValue();
      if (!recaptchaValue) {
        return false;
      }
      return true;
    },
    reset: () => {
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    },
    getValue: () => {
      return recaptchaRef.current?.getValue() || null;
    },
  }));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "1rem",
      }}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY}
        theme="light"
      />
    </div>
  );
});

Captcha.displayName = "Captcha";

export default Captcha;
